// 创建文件en/index.js
const Jap = {
    rejected: "拒否されました",
    my: "私の",
    today: "今日",
    this_week: "今週",
    this_month: "今月",
    last_month: "先月",
    this_year: "今年",
    number_of_people: "人数",
    amount: "金額",
    enter_username_id_to_search: "ユーザー名IDを入力して検索",
    team_list: "チームリスト",
    registration_time: "登録日時",
    selling_face_value: "売却額面",
    click_for_details: "詳細をクリック",
    "agent_login": "エージェントログイン",
    'SignOut': 'アカウントをログアウト',
    'Contact us': "お問い合わせ",
    'Download our app': "アプリをダウンロード",
    'Download it from': "ダウンロードURL",
    'About Us': "私たちについて",
    'Gobuy USA was founded in 2012': "Gobuy USA は 2012 年に設立されました",
    'Customer service': "顧客サービス",
    'frequently asked question': "常见问题",
    'Return and exchange policy': "返品および交換ポリシー",
    'Shipping and distribution': "配布・配送",
    'Contact us by email': "電子メールでお問い合わせください",
    'Privacy Policy and Terms of Use': "プライバシーポリシーと利用規約",
    'Privacy Policy': "プライバシーポリシー",
    'Terms of use': "利用規約",
    'Upload credentials': "認証情報のアップロード",
    'The withdrawal is being processed': "出金中です",
    'Cause of failure': "失敗の理由",
    'Your shopping cart is still empty': "ショッピングカートはまだ空です",
    'Log in to view the items in your cart': "ログインしてショッピング カート内の商品を表示します",
    'Browse around': "ブラウズ",
    'Account correlation': "アカウント関連",
    'Order management': "注文管理",
    'Payment method': "支払方法",
    'Collection address': "支払い先住所",
    Category: "分類",
    "MyCommission": "私の任務",
    "Gross income": "総収益",
    "Direct commission": "直接手数料",
    "Indirect commission": "間接手数料",
    "Transfer to wallet": "ウォレットに転送する",
    "Tip: The transfer amount must be greater than 10USDT": "ヒント: 送金金額は 10USDT より大きくなければなりません",
    "transfer": "移行",
    "commission": "手数料",
    "Please enter": "入力してください",
    'Old Password': "以前のパスワード",
    'Change password': "パスワードを変更する",
    'Amazon GIFT CARD': "アマゾンギフト券",
    'High Priced Recycling': "高価リサイクル",
    'Data': "日付",
    'congratulations': "おめでとう",
    'Obtain': "得る",
    'ThankYouForParticipating': "ご参加いただきありがとうございました",

    // navbar"",
    Home: "フロントページ",
    Search: "検索",
    ShoppingCart: "ショッピングカート",
    Mine: "私の",

    // 首页
    // 搜索
    EnterSearchContent: "検索内容を入力してください",
    'Recent searches': "最近の検索",
    'popular searches': "人気の検索",
    'Please search': "検索したいキーワードを入力してください",
    'orderSearch': "注文名または製品名を入力して検索します",

    // 语言
    'Language selection': "言語の選択",

    // menu
    Brand: "ブランド",
    Collect: "集める",
    Manage: "管理",
    Order: "注文",
    Wallet: "財布",
    BlindBox: "ブラインドボックス",
    MenuGiftCard: "ギフトカード",
    // HotSale
    HotSale: "最新ニュースが発売中です...",
    // tabs"",
    TodaysOffer: "プラットフォーム推奨",
    'Phone': "携帯電話",
    'Smart Watch': "スマートウォッチ",
    'Smart bracelet': "スマートブレスレット",

    // gobuy
    'home.gobuy.title': "驚きがあなたを待っています",
    'home.gobuy.periods': "ブラインドボックス ラウンド",
    'home.gobuy.freeze': "カウントダウンに参加する",
    'home.gobuy.drawing': "カウントダウン開始",
    'home.gobuy.buy': "参加する",
    'home.gobuy.isbuy': "すでに参加しています",
    USDT: "USDT",
    'home.gobuy.jackpot': "賞金総額",
    Purse: "財布",
    Box: "ブラインドボックス",
    'GetAPrize': "賞品を獲得する",
    Discount: "割引",
    when: "いつ",
    points: "積分",
    seconds: "2番",
    // MessageBox
    'MessageBox.Tips': "ヒント",
    'MessageBox.Confirm': "確認する",
    'MessageBox.Cancel': "キャンセル",
    'MessageBox.buy.box': "このブラインドボックスを購入してもよろしいですか?",
    // Toast
    'succ': "成功",
    'err': "間違い",
    'box.succeeds': "購入が成功しました",
    'box.frozen': "すでに参加しています",
    'box.issue': "ブラインドボックスは1号につき1枚のみ購入可能です",

    // 商品列表
    filter: "フィルター",
    sales: "販売数量",
    selfOP: "自走式",
    noMore: "もうない",
    brand: "ブランド",
    confirm: "確認する",
    reset: "リセット",
    ComSor: "総合仕分け",
    MostPop: "最も人気のある",
    HighLow: "価格が高いものから安いものまで",
    LowHigh: "価格が安いものから高いものまで",
    SalVol: "販売量",
    NewArr: "新着",

    // 购物车
    'cart.cart': "ショッピングカート",
    'cart.edit': "編集",
    'cart.done': "仕上げる",
    'home.cart.voucher': "クーポンを入手する",
    'home.cart.outstock': "在庫切れ",
    'home.cart.offshelf': "棚から削除されました",
    'Only': "のみ",
    'left': "個人的な",
    'Promotion': "プロモーション",
    'cart.all': "すべて選択",
    'cart.total': "合計",
    'cart.delete': "消去",
    'cart.checkout': "お勘定お願いします",

    // 我的
    'Direct': "直接",
    'Indirect': "間接的な",
    'MyOrders': "私の注文",
    'ViewAll': "すべて見る",
    'Unpaid': "支払い保留中",
    'ToShip': "出荷待ち",
    'ToReceive': "受け取り待ち",
    'ToReview': "評価待ち",
    // 盲盒
    'MyBlindBox': "ブラインドボックス一覧",
    'WaitingDraw': "抽選を待っています",
    'Opened': "開封済み（受け取り/返品）",
    // 礼品卡
    'After sale': "アフターセールス",
    'GiftCard': "リサイクル記録",
    'RecycleGiftCard': "ギフトカードをリサイクルする",
    'Verifying': "チェック",
    'Rebuying': "再購入",
    'Repurchased': "支払い待ち",
    'Paid': "支払いが完了しました",
    // 常用工具
    'CommonTools': "共通ツール",
    'MyWallet': "私の財布",
    'VirtualOrders': "仮想秩序",
    'Refunds': "返金",
    'MyFriends': "私の友人",
    'ChatList': "チャットリスト",
    'RealNameVerification': "実名認証",
    'MyFavorites': "私のコレクション",
    'Addresses': "アドレス管理",
    'MyReviews': "私のレビュー",
    'BrowsingHistory': "閲覧履歴",
    'Promotions': "プロモーション",
    'StoreManagement': "店舗管理",
    'BecomeASeller': "販売者になる",

    // 订单列表
    'SearchPlaceholder': "注文商品名を入力して検索します",
    All: "全て",
    OrderNo: "注文番号",
    items: "個",
    ShippingFee: "貨物",
    'Refund in Progress': "返金中です",
    'Cancel Order': "注文をキャンセルする",
    'Refund': "返金",
    'Track Shipping': "物流をチェックする",
    'Confirm Receipt': "商品の受領を確認する",
    'Evaluate': "評価する",
    'Delete': "消去",
    'Pay': "支払い",
    'MessageBox.delete.order': "この注文を削除してもよろしいですか?",
    'MessageBox.cancel.order': "この注文をキャンセルしてもよろしいですか?",
    'MessageBox.receive.order': "この注文は受領されましたか?",
    // 订单详情
    'Order Details': "注文の詳細",
    'Pickup Code': "ピックアップコード",
    'Complaint': "苦情",
    'After-Sales': "アフターセールス",
    'Gift': "贈り物",
    'Order Date': "注文日",
    'Used voucher worth': "バウチャーの使用金額",
    'CNY': "人民元",
    'Payment Method': "支払方法",
    'Total Product Amount': "商品合計金額",
    'Shipping Fee': "貨物",
    'Amount Paid': "支払った金額",
    'Return': "商品を返品する",
    // 盲盒列表
    'Pending Draw': "宝くじの抽選待ち",
    'Pending Unboxing': "オープン予定",
    'Unboxed': "すでにオンになっています",
    'Collected': "受け取った",
    'Recycled': "リサイクル",
    'Unknown': "未知",
    'Claim': "受け取る",
    'Recycle': "自社株買い ",
    'Unbox': "オンにする",
    'MessageBox.recycle.box': "このブラインドボックスをリサイクルしてもよろしいですか?",
    // 盲盒详情
    'Mystery Box Details': "ブラインドボックス詳細",
    'Unopened': "電源が入っていない",
    'box.opened': "電源が入っていない",
    'Claimed': "受け取った",
    'Confirm Claim': "回収の確認",
    'MessageBox.pick.box': "このブラインド ボックスを抽出してもよろしいですか?",
    // 盲盒提货
    'Please add address': "住所を追加してください",
    // 礼品卡列表
    'Face Value Total': "額面総額",
    // 礼品卡详情
    'Gift Card Details': "ギフトカードの詳細",
    'Card number': "カード番号",
    'Activation code': "アクティベーションコード",
    'Actual recovery price': "実際のリサイクル価格",
    // 礼品卡回收
    'Gift Card Recycling': "ギフトカードのリサイクル",
    'Confirm Recycling': "リサイクルの確認",
    'Please enter the card number': "カード番号を入力してください",
    'Please enter the activation code': "アクティベーション コードを入力してください",
    'MessageBox.recycle.gift': "このギフトカードをリサイクルしてもよろしいですか?",

    // 我的钱包
    'My Wallet': "私の財布",
    'Available Balance': "利用可能残高",
    'Frozen Funds': "資金を凍結する",
    'Recharge': "補充する",
    "can": "可",
    'Withdraw': "現金を引き出す",
    'Withdrawal Accounts': "引き出し口座",
    // 充值
    'Recharge Details': "リチャージの詳細",
    'Recharge Order No.': "リチャージ注文番号",
    'Recharge Amount': "チャージ金額",
    'Creation Time': "作成時間",
    'MessageBox.recharge.pop': "チャージ金額を入力してください",
    // 付款
    'payment': "支払い",
    'Order submitted successfully, please select payment method': "注文は正常に送信されました。支払い方法を選択してください",
    'Rechargeable card': "リチャージ可能なカード",
    'Please enter a hash': "ハッシュを入力してください",
    'Immediate payment': "今すぐお支払いください",
    'Wait for the file to load': "ファイルがロードされるまでお待ちください",
    // 提现
    'Withdrawal Details': "出金詳細",
    'Withdrawal Amount': "出金額",
    'Application Time': "申請時間",
    'New Application': "新しいアプリケーション",
    'Payment Password': "支払いパスワード",
    'New Payment Password': "新しい支払いパスワード",
    'Recipient Information': "受取人情報",
    'Submit': "提出する",
    'Add Recipient Account First': "まず支払いアカウントを追加してください",
    'Please bind your mobile phone or email first': "まず携帯電話または電子メールをバインドしてください",
    // 设置
    'Account Settings': "アカウント設定",
    'Change Login Password': "ログインパスワードを変更する",
    'Change Payment Password': "支払いパスワードを変更する",
    'Log Out': "サインアウト",
    'Mobile': "携帯電話",
    'Verification Code': "検証コード",
    'Email': "郵便",
    'New Password': "新しいパスワード",
    'Confirm Password': "パスワードを認証する",
    'Modify': "改訂",
    'Bind': "バインディング",
    ' Mobile': "携帯電話",
    ' Email': "郵便",
    // 资金详情
    'Fund Details': "資金調達の詳細",
    'Withdrawal Account': "引き出し口座",
    'Account Type': "アカウントの種類",
    'USDT Address (TRC20)': "USDTアドレス(TRC20)",
    'Edit': "編集",
    'Delete': "消去",
    'Add New': "新しいアカウントを追加",
    'MessageBox.delete.bank': "この引き出し口座を削除してもよろしいですか?",
    // 登录
    'Login': "ログイン",
    'Sign Up': "登録する",
    'Normal Login': "通常ログイン",
    'Username / Email / Phone Number': "ユーザー名/メールアドレス",
    'Enter Phone Number': "携帯電話番号を入力してください",
    'Enter Email': "メールアドレスを入力してください",
    'Enter SMS Code': "SMS認証コードを入力してください",
    'Enter Password': "パスワードを入力してください",
    "enter_login_password_for_verification": "ログインパスワードを入力して認証してください",
    'Forgot Password': "パスワードを忘れる",
    'Third-party Login': "サードパーティのログイン",
    'Please complete the form': "フォームに記入してください",
    'WeChat': "微信",
    'Weibo': "微博",
    'QQ': "QQ",
    'phone login': "モバイルログイン",
    'Login Expired': "ログイン期限が切れました",
    'Please enter your phone number first': "最初に携帯電話番号を入力してください",
    'Please enter your username/email/phone number': "ユーザー名/メールアドレスを入力してください",
    'Please enter your password': "パスワードを入力してください",
    'Password must be at least 6 characters': "パスワードは6文字以上である必要があります",
    'Please enter an 11-digit phone number': "11桁の携帯電話番号を入力してください",
    'Please wait for the file to finish loading': "ファイルがロードされるまでお待ちください",
    'send': "送信",
    'signUpTips': "あなたの個人データは、ウェブサイト全体でのエクスペリエンスのサポート、アカウントへのアクセスの管理、および当社のプライバシー ポリシーに記載されているその他の目的に使用されます。",

    // 注册
    'Sign Up': "登録する",
    'Referrer': "推薦者",
    'Invitation code': "招待コード",
    'Invite friends': "友達を招待する",
    'Username': "ユーザー名",
    'Full Name': "本名",
    'Set Password': "パスワードを設定する",
    'Confirm Password': "パスワードを認証する",
    'Phone Number': "電話番号",
    'Email': "電子メール",
    'Username: 3-25 chars, letters & numbers': "ユーザー名: 3 ～ 25 文字の文字と数字",
    '6-20 digits/letters/symbols': "6～20の数字/文字/記号",
    'By clicking sign up, you agree to': "クリックして登録すると、同意したものとみなされます",
    'User Agreement': "ユーザー同意書",
    'Please check the user agreement': "利用規約をご確認ください",
    'Please enter a username with 3-25 characters': "3 ～ 25 文字のユーザー名を入力してください",
    'Enter SMS Verification Code': "SMS認証コードを入力してください",
    'Please enter your phone number': "携帯電話番号を入力してください",
    'Please enter the verification code': "確認コードを入力してください",
    'Please enter a 6-digit verification code': "6桁の認証コードを入力してください",
    'Please enter a password with 6-20 characters': "6～20文字のパスワードを入力してください",
    'Please enter the confirm password': "確認用のパスワードを入力してください",
    'The confirm password does not match the entered password': "確認パスワードが入力されたパスワードと一致しません",

    // 密码恢复
    'Password Recovery': "パスワードの回復",
    'Forgot Password': "パスワードを忘れる",
    'Forget.email.tips': "アカウントがまだ電子メール番号に関連付けられていない場合は、プラットフォーム管理者に連絡してパスワードを回復してください。",

    // 通知
    'Notification Message': "通知メッセージ",
    'Direct Message': "プライベートメッセージ",
    'System Message': "システムメッセージ",
    'Leave a Message': "メッセージ",

    // 配送地址
    'Delivery Address': "お届け先の住所",
    'The store is no longer valid, please edit the delivery address again': "このストアは無効になりました。配送先住所を再編集してください",
    'Default address': "デフォルトアドレス",
    'Add address': "アドレスを追加",
    'Edit address': "住所を編集する",
    'MessageBox.delete.address': "このアドレスを削除してもよろしいですか?",
    'name': "名前",
    'phone': "電話番号",
    'district': "地区",
    'address': "住所",
    'default address': "デフォルトアドレス",
    'save and use': "保存して使用する",
    'save': "保存",
    'Please select a region': "地域を選択してください",
    'Please fill in the recipient name': "受信者名を入力してください",
    'Name must be 2-15 characters': "名前は 2 ～ 15 文字にする必要があります",
    'Please fill in the mobile phone number': "携帯電話番号を入力してください",
    'Please select your location': "所在地を選択してください",
    'Please fill in the detailed address': "詳しい住所をご記入ください",

    // 浏览历史
    'Browsing History': "閲覧履歴",
    'Clear browsing history': "閲覧履歴をクリアする",

    // 推广会员
    'Promotion member': "メンバーを昇格させる",
    "“PromotionPoster”": "プロモーションポスター",
    "MemberName": "メンバー名",
    "MyAssets": "私の資産",
    "DistributedAmount": "分配金",
    "NumberOfDistributedProducts": "製品数量の割り当て",
    "DistributedProductAmount": "分配金",
    "MyTeam": "私のチーム",
    "LevelOneMembers": "ファーストクラスメンバー",
    "LevelTwoMembers": "第二レベルのメンバー",
    "PromotionPoster": "プロモーションポスター",
    "PromotionMembers": "メンバーを昇格させる",
    "PromotionPerformance": "プロモーションパフォーマンス",
    "ViewPromotionLink": "クリックしてプロモーションリンクを表示",
    "PromoteViaWeChatQRCode": "WeChat QR コードで宣伝する",
    "Copy": "コピー",
    "BrowserNotSupportedCopyManually": "お使いのブラウザは直接コピーをサポートしていません。手動でコピーしてください",
    "GiftCardRecoveryTotal": "リサイクルされたギフトカードの総数",
    "TodaysGiftCardRecoveryCount": "本日のギフトカードのリサイクル数",
    "RegistrationDate": "登録日",
    "LastLogin": "最終ログイン",
    "Promotion Commission": "販売促進手数料",

    // userinfo 个人信息
    "Personal Info": "個人情報",
    "Nickname": "ニックネーム",
    "Birthdate": "生年月日",
    "Save": "保存",
    "CropImage": "写真をトリミングする",
    "UseImage": "写真を使用する",

    // goodsDetail 商品详情
    "Off": "割引",
    "Sold": "売られた",
    "Product": "製品",
    "Comment": "コメント",
    "Details": "詳細",
    "ReportViolation": "報告",
    "Cart": "ショッピングカート",
    "ChatMessages": "チャットメッセージ",
    "MyShop": "私の店",
    "MerchantLogin": "販売者のログイン",
    "Share": "共有",
    "ShareTo": "共有先",
    "WeChat": "微信",
    "Copy": "コピー",
    "Poster": "ポスター",
    "BrowserNotSupportedCopyManually": "お使いのブラウザは直接コピーをサポートしていません。手動でコピーしてください",
    "Follow": "焦点を当てる",
    "Unfollow": "フォローを解除する",
    "PleaseSelectQuantityAndCategory": "数量とカテゴリを選択してください。",
    "SelectedWithQuantity1": "{仕様}、数量 {数値} を選択しました。",
    "SelectedQuantity1": "選択した数量 {数値}。",
    "SelectedWithQuantity2": "{仕様}、数量 {数値} を選択しました。",
    "Add to cart": "カートに追加する",
    "Buy now": "即購入",
    "Stock": "在庫あり",
    "Pieces": "個",
    "Quantity": "量",
    "All": "全て",
    "Good": "良いレビュー",
    "Medium": "中立の評価",
    "Bad": "悪いレビュー",
    // 评论
    "Product review": "製品レビュー",
    "anonymous": "匿名",
    "noReviewInfo": "コメント情報は提供されていません",
    "Shop Owners Response": "店主が答える",
    "This product has no current reviews": "現在、この商品にはレビューがありません",
    "Product details": "製品詳細",
    "shop": "店",
    "customerService": "顧客サービス",
    "shoppingCart": "ショッピングカート",
    "addToCart": "カートに追加する",
    "buyNow": "即購入",
    "outOfStock": "選択された商品は現在在庫切れです、申し訳ございません。",
    "notAvailable": "選択した製品はもう入手できません。申し訳ありません。",
    "Store order message": "ストアオーダーニュース",
    "Confirm the order": "注文を確認する",
    "productAmount": "商品金額",
    "discount": "割引",
    "shippingFee": "貨物",
    "subtotal": "ストア小計",
    "Submit an order": "注文を送信する",
    // 退货
    "refundAdd": "返金を追加する",
    "back": "戻る",
    "refundDescription": "返金手順:",
    "proofOfRefund": "払い戻し伝票",
    "use": "使用",
}
export default Jap
